<template>
  <div class="container-fluid">
    <div class="row py-4">
      <div class="col-md-3 text-md-right">
        <label for="name">Name</label>
      </div>
      <div class="col-md-7">
        <el-input type="text" name="name" v-model="eventName" class="w-100" />
      </div>
    </div>
    <div class="row py-2">
      <div class="col-md-3 text-md-right">
        <label></label>
      </div>
      <div class="col-md-7 d-flex justify-content-center">
        <el-button round size="large" class="secondary-button mr-2" @click="closeModal"
          >Cancel</el-button
        >
        <el-button
          round
          class="ml-2 text-white"
          :color="primarycolor"
          size="large"
          @click="createCategory"
          :loading="isSaving"
          >Save</el-button
        >
      </div>
    </div>
  </div>

</template>

<script>
import { ref, inject } from "vue";
import eventsService from "../../services/events/eventsservice";
import { ElNotification } from 'element-plus'

export default {
  setup(props, { emit }) {
    const eventName = ref("");
    const isSaving = ref(false);
    const primarycolor = inject("primarycolor");
  
    const createCategory = async () => {

      isSaving.value = true;
      try {
        const response = await eventsService.createNewEventCategory(
          eventName.value
        );    
        
        if (response) { // Check for response.data if your API wraps data
          ElNotification({
            message: "Category created successfully",
            type: "success",
          });
          emit(
            "new-created",
            response.map((i) => {
              return { id: i.id, name: i.name };
            }),
            eventName.value
          );

          // Emit simpler event - just the created category
          
          
          // Clear the input
          // eventName.value = "";
          isSaving.value = false;
        } else {
          ElNotification({
            title: "Operation Failed",
            message: "Category could not be created",
            type: "error",
          });
          isSaving.value = false;
        }
      } catch (error) {
        console.log(error);
        
        emit("closeeventmodal");
        ElNotification({
          title: "Error",
          message: "Category could not be created",
          type: "error",
        });
        isSaving.value = false;
      } 
    };

    const closeModal = () => {
      emit("closeeventmodal");
    };

    return {
      primarycolor,
      closeModal,
      eventName,
      createCategory,
      isSaving
    };
  },
};
</script>

<style scoped></style>
